import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {DataService} from './shared/data.service';
import {UserRolesService} from './services/user-roles.service';
import {filter} from "rxjs";
import {TokenInterface} from "@app/Interfaces/token.interface";
import {jwtDecode} from "jwt-decode";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  showTable = false;
  showRegistry = false;
  showQuarantine = false;
  showRedistributions = false;
  showCreateQuarantine = false;
  isRedistributions = false
  isRedistributionsRequest = false
  navItems: {link: string, title: string, subTitle: string, isHidden?: boolean, breadcrumbs?: string[]}[] = [
    {
      link: '/',
      title: 'Реєстр наявних лікарських засобів і медичних виробів',
      subTitle: '',
    },
    {
      link: '/redistributions/offers',
      title: 'Перерозподіл',
      subTitle: 'Перерозподіл',
    },
    {
      link: '/redistributions/requests',
      title: 'Перерозподіл',
      subTitle: 'Перерозподіл',
      isHidden: true
    },
    {
      link: '/quarantine',
      title: 'Карантин медичних товарів',
      subTitle: '',
    },
    {
      link: '/sign-demo',
      title: 'КЕП Демо',
      subTitle: '',
    },
  ];

  constructor(
    private router: Router,
    private dataService: DataService,
    protected userRole: UserRolesService
  ) {
  }
  
  token: TokenInterface = jwtDecode(localStorage['access_token']);
  
  isPageQuarantineAvailable = this.token.realm_access.roles.includes('accounting-register-viewer-role') &&
      (this.token.realm_access.roles.includes('moz-member-role') ||
          this.token.realm_access.roles.includes('doz-member-role') ||
          this.token.realm_access.roles.includes('zoz-member-role'))

  ngOnInit(): void {
    this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.showQuarantine= false
          this.showRegistry = false;
          this.showTable = false;
          this.dataService.showMyOrganization = false;
          this.showRedistributions = false;
          this.showCreateQuarantine = false;
          this.isRedistributions = false;
          this.isRedistributionsRequest = false;

        if (this.router.url === '/') {
          this.showRegistry = true;
        }
        if (this.router.url === '/redistributions/offers') {
          this.showRedistributions = true;
          this.isRedistributions = true;
        }
        if (this.router.url === '/redistributions/requests') {
          this.showRedistributions = true;
          this.isRedistributions = true;
          this.isRedistributionsRequest = ['moz', 'doz'].includes(this.dataService.userRoleValue.value);
          
        }
        if (this.router.url === '/quarantine' && this.isPageQuarantineAvailable) {
          this.showRedistributions = true;
          this.showCreateQuarantine = true;
          this.showQuarantine= true
          this.dataService.showMyOrganization = true;
        }
    });
  }

  redirectToCreateQuarantine() {
    this.router.navigate(['quarantine/create-quarantine-placement']);
  }

  redirectToCreateredistributionRequest() {
    this.router.navigate(['redistributions/create-request']);
  }

  onAppContentChange({state}: { state: 1 | 2 }): void {
    this.showTable = state === 2;
  }

  onAppRedistributionSwitch({state}: { state: 1 | 2 }): void {
    let url = state === 1 ? '/redistributions/offers' : '/redistributions/requests';
    this.router.navigate([url]);
    // this.dataService.redistributionSwitcherStatus.next(state);
  }
}
